import { Column } from "@faire/web/slate/Layout";
import { Modal } from "@faire/web/slate/Modal";
import { getSpacing, GrowingSpacer, Spacer } from "@faire/web/slate/spacing";
import React from "react";
import styled, { css } from "styled-components";
import { useLoggedOutContactUsNavigation } from "../hooks/useLoggedOutContactUsNavigation";
import { LoggedOutContactUsStepCta } from "./LoggedOutContactUsStepCta";
import { LoggedOutContactUsStepView } from "./LoggedOutContactUsStepView";
export var LoggedOutContactUsModal = function LoggedOutContactUsModal() {
  var _useLoggedOutContactU = useLoggedOutContactUsNavigation(),
    isFirstStep = _useLoggedOutContactU.isFirstStep,
    isLastStep = _useLoggedOutContactU.isLastStep,
    goToPrevStep = _useLoggedOutContactU.goToPrevStep,
    closeModal = _useLoggedOutContactU.closeModal;
  var onBack = !isFirstStep && !isLastStep ? goToPrevStep : undefined;
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    onBack: onBack,
    shouldCloseOnOverlayClick: false,
    width: "600px"
  }, /*#__PURE__*/React.createElement(Container, {
    "$isLast": isLastStep
  }, /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), /*#__PURE__*/React.createElement(LoggedOutContactUsStepView, null), /*#__PURE__*/React.createElement(GrowingSpacer, null), /*#__PURE__*/React.createElement(LoggedOutContactUsStepCta, null)));
};
var Container = styled(Column).attrs({
  align: "stretch",
  justify: "space-between"
}).withConfig({
  displayName: "LoggedOutContactUsModal__Container"
})(["padding:", ";width:100%;", ""], getSpacing("8x", "3x", "4x"), function (props) {
  return !props.$isLast ? css(["min-height:700px;"]) : css(["height:auto !important;"]);
});